<script setup lang="ts">
import { computed } from 'vue'
import { MenubarRoot, type MenubarRootEmits, type MenubarRootProps, useForwardPropsEmits } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<MenubarRootProps & { class?: string }>()
const emits = defineEmits<MenubarRootEmits>()

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
const activeValue = ref<string>('')
</script>

<template>
    <MenubarRoot
        v-bind="forwarded"
        v-model:model-value="activeValue"
        :class="cn('flex items-center gap-x-6', props.class)"
    >
        <div
            v-if="activeValue"
            class="bg-plus-lp-black/20 absolute left-0 top-[calc(var(--lp-menu-bar-client-type)+var(--lp-menu-bar-desktop))] h-screen w-screen backdrop-blur-sm"
        />
        <slot />
    </MenubarRoot>
</template>
